import React from 'react';

export const DropdownMenuMockContext = React.createContext<{
  defaultOpen: boolean;
}>({
  defaultOpen: false,
});
